import styled from 'styled-components';

export const Main = styled.div`
    display: flex;
    row-gap: 12px;
    align-items: center;
    column-gap: 12px;
    width: fit-content;
`;
